import { IDemands, IDemandsResponse } from 'types/demands';
import api from '../services/config/api';

export const createDemand = (data: Omit<IDemands, 'areaInterna'> & { areaInterna: string }) =>
  api.post<IDemandsResponse>('/solicitacao', data);

// export const createClientDemand = (
//   data: Omit<IRequestDemands, 'serviceType'> & { serviceType: { id: number } },
// ) => api.post('/solicitacao/documentos-consultas', data);

export const createClientDemand = (data: FormData) =>
  api.post('/solicitacao/documentos-consultas', data);

export const createClientVersion = (id: string | number, data: FormData) =>
  api.post<IDemandsResponse>(`/solicitacao/${id}/solicitacao-versao`, data);

export const getClientVersion = (id: string | number) =>
  api.get(`/solicitacao/${id}/solicitacao-versao`);

export const getClientFile = (id: string | number) =>
  api.get<Blob>(`/solicitacao/download/${id}/solicitacao-versao`, {
    responseType: 'blob',
  });
export const removeClientFile = (id: string | number) =>
  api.delete(`/solicitacao/${id}/solicitacao-versao`);
